// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"23f82a8c","638":"0b92da5d","994":"678bc032"}[chunkId] + ".chunk.css";
};